<template>
  <div class="page-container">
    <Sidebar />
    <div class="main-content">
      <AdminTable :apiEndpoint="'/api/admin/expert-articles'" :columns="config.columns" :filters="config.filters" :formFields="config.formFields" :title="config.title" />
    </div>
  </div>
</template>

<script>
import Sidebar from '../components/Sidebar.vue'
import AdminTable from '@/components/AdminTable.vue'
import { TABLES_CONFIG } from '@/config/tables'

export default {
  name: 'ExpertArticles',
  components: { Sidebar, AdminTable },
  data() { return { config: TABLES_CONFIG.expert_articles } }
}
</script>

<style scoped>
.page-container { display: flex; min-height: 100vh; background: #f5f5f5; }
.main-content { flex: 1; margin-left: 260px; padding: 30px; }
</style>
